import { Slider, styled } from "@mui/material";

const CustomSlider = styled(Slider)(({ theme, value, styles = {} }) => ({
  height: "0.5rem",
  "& .MuiSlider-track": {
    border: "none",
    background:
      value < 40
        ? "linear-gradient(90deg, #FCFFBD 0%, #FFB400 100%)"
        : value >= 40 && value <= 60
        ? "linear-gradient(90deg, #8EEBFF 0%, #4BC7E1 100%)"
        : value > 60 && value <= 90
        ? "#9048FB54"
        : value > 90
        ? "linear-gradient(90deg, #FF9A9E 0%, #FF5B5B 100%)"
        : "linear-gradient(90deg, #8EEBFF 0%, #4BC7E1 100%)",
  },
  "& .MuiSlider-rail": {
    opacity: 0.5,
    backgroundColor: "#E0E0E0",
  },
  "& .MuiSlider-thumb": {
    height: "1.3rem",
    width: "1.3rem",
    backgroundColor: "#fff",
    border: "0.1875rem solid #9147F5", // 3px
    "&:focus, &:hover, &.Mui-active": {
      boxShadow: "inherit",
    },
  },
  "& .MuiSlider-mark": {
    backgroundColor: "#B6E5FF",
    height: "0.5rem",
    width: "0.5rem",
    borderRadius: "50%",
    "&.MuiSlider-markActive": {
      backgroundColor: "#9048FB",
    },
  },
  "& .MuiSlider-valueLabel": {
    backgroundColor: "#9147F5",
    color: "#fff",
    fontSize: "0.75rem",
    borderRadius: "0.25rem",
    "& *": {
      background: "transparent",
      color: "inherit",
    },
  },

  ...styles,
}));

export default CustomSlider;
